export const pkg = {
  name: 'isomorphic-git',
  version: '1.43.0',
  agent: 'git/isomorphic-git@1.43.0',
}
